import React from "react";
import { Card, Text } from "@nextui-org/react";
import { motion } from "framer-motion";

const KpiCard = ({ label, value, bg, textColor, valueColor }) => (
  <Card variant="flat" css={{ p: "12px", bg }}>
    <Text size="11px" b transform="uppercase" color={textColor}>
      {label}
    </Text>
    <Text size="16px" b color={valueColor}>
      &#8377; {Math.ceil(value || 0).toLocaleString("en-IN")}
    </Text>
  </Card>
);

const AltEntriesKpiGrid = ({ kpiStats = {} }) => {
  const {
    shopTotal = 0,
    sunilC = 0,
    customerTotal = 0,
    profit = 0,
  } = kpiStats;

  return (
    <motion.div
      className="alignDivCenter"
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "10px",
        maxWidth: "550px",
        margin: "0 auto 10px auto",
        padding: "0 16px",
      }}
    >
      <KpiCard
        label="Shop Total"
        value={shopTotal}
        bg="$warningLight"
        textColor="$warning"
        valueColor="warning"
      />
      <KpiCard
        label="Sunil C"
        value={sunilC}
        bg="$red50"
        textColor="$red800"
        valueColor="error"
      />
      <KpiCard
        label="Customer"
        value={customerTotal}
        bg="$gray100"
        textColor="$gray800"
        valueColor="default"
      />
      <KpiCard
        label="Profit"
        value={profit}
        bg={profit >= 0 ? "$blue50" : "$red50"}
        textColor="$gray800"
        valueColor={profit >= 0 ? "secondary" : "error"}
      />
    </motion.div>
  );
};

export default AltEntriesKpiGrid;
